<mf-container>
  <mf-row-separator [minHeight]="120"></mf-row-separator>
  <mf-column [md]="3"></mf-column>
  <mf-column [md]="6">
    <mf-section>
      <mf-row>
        <mf-button-google
          text="Continuar con Google"
          (click)="loginGoogle()" />
      </mf-row>
      <mf-row-separator [minHeight]="30"></mf-row-separator>
      <form
        [formGroup]="authForm"
        (keyup.enter)="login()">
        <mf-row>
          <mf-field-text formControlName="username" />
        </mf-row>
        <mf-row>
          <mf-field-password formControlName="password" />
        </mf-row>
        @if(errorMessage()) {
        <mf-row>
          <mf-alert type="danger">
            {{ errorMessage() }}
          </mf-alert>
        </mf-row>
        }
        <mf-row align="center">
          <mf-button
            text="Ingresar"
            [isLoading]="isLoading"
            (click)="login()" />
        </mf-row>
      </form>
    </mf-section>
  </mf-column>
</mf-container>
